import { Dialog, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Dialog)``;

export const Container = styled(Stack)`
  background: linear-gradient(0deg, #fff 0%, #f1f4ff 100%);
  padding: ${(p) => p.theme.spacing(1.5)};
`;
